import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "bulkActions", "invoiceIds"]
  
  connect() {
    this.updateSelectAllState()
    this.updateBulkActions()
  }

  selectAllChanged() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateBulkActions()
  }

  checkboxChanged() {
    this.updateSelectAllState()
    this.updateBulkActions()
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget || this.checkboxTargets.length === 0) {
      return
    }

    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    const someChecked = this.checkboxTargets.some(cb => cb.checked)
    
    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = someChecked && !allChecked
  }

  updateBulkActions() {
    if (!this.hasBulkActionsTarget || !this.hasInvoiceIdsTarget) {
      return
    }

    const selectedIds = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (selectedIds.length > 0) {
      this.bulkActionsTarget.classList.remove('d-none')
      this.invoiceIdsTarget.value = selectedIds.join(',')
    } else {
      this.bulkActionsTarget.classList.add('d-none')
      this.invoiceIdsTarget.value = ''
    }
  }

  submitForm(event) {
    const selectedIds = this.invoiceIdsTarget.value
    if (!selectedIds || selectedIds.trim() === '') {
      event.preventDefault()
      alert('Please select at least one invoice.')
      return false
    }
  }
}
